module.exports = __webpack_public_path__ + "static/media/cover-img.2e87776a.jpg";